import * as React from 'react';
import { COMPONENT_MENU, NON_REPEATABLE_CONTROL_TYPES, REDIRECT_CANDIDATE_TYPE_PROPERTY_NAME } from '../../constants';
import { IComponent, EComponentTypes, clone, ComponentHelper, IComponentType, PropertyHelper, IComponentMethods, SharedJourneyHelper, ErrorHelper, EModalType, EConfirmationOperationType, EConditionTypes } from '../../helpers';
import { Properties, ControlList, Action, Decision, SharedJourney, Submission, Summary, Loop } from '../';
import {
    Button, ButtonType,
    ContextualMenu, IContextualMenuItem, DirectionalHint, TextField
} from 'office-ui-fabric-react';
import { Redirect } from './redirect';
import Collapsible from 'react-collapsible';
import store from '../../store/store';
import { PropertiesTitle } from '../common/properties-title';
import CascadeContainer from '../../containers/cascade';
import types from '../../store/types';
import OutsideClickHandler from 'react-outside-click-handler';
import { CollapseContent } from './collapse-content';

interface IProps extends IComponentMethods {
    branchId: string;
    component: IComponent;
    components: any;
    invalidConnection: boolean;
    isStartComponent: boolean;
    previousOutputBlocks: any;
    setNextComponentId: (elementId: string, componentId: string, nextComponentId: string, elementType: string) => any;
    toggleSharedJourneyConfig: (componentId: string, previousOutputBlocks: any) => void;
    // toggleDialog: (componentId: string, controlIndex: number) => void;
    toggleControlBlockLoopingDialog: (componentId: string, previousOutputBlocks: any) => void;

    updateComponentName?: (name: string, value: string, componentId: string) => void;
    conditions?;
    element?;
    inLoop: boolean;
    isCollapsibleComponent: boolean;
    saveEditedBranch?: (val?: number) => void;
    changeEditComponentId?: (val: string, branchIndex?: number) => void;
    nameChange?: (name: string) => void;
    deleteBranch?: (index: number, componentId?: string) => void;
    decisionItems?: any[];
    parentDecisionID?: string;
    index?: number;
    collapsibleContextMenu?: JSX.Element;
    toggleShowMenu?: (showMenuVal: boolean, showMenuIndexVal: number) => void;
    showMenu?: boolean;
    editComponentId?: string;
    editIndex?: number;
    prevDecisionItems?: any;
    addNewLayoutPanel?: (componentId: string) => void;
};

export class Component extends React.Component<IProps, any> {
    private inputTimeout;

    constructor(props) {
        super(props);
        this.state = {
            showMenu: false,
            showMenuIndex: null,
            editComponentId: null,
            editIndex: null,
            showCollapsibleContent: false
            // showCollapsibleContent: false
        };
        this.changeShowCollapsibleContent = this.changeShowCollapsibleContent.bind(this);
        this.changeShowMenu = this.changeShowMenu.bind(this);
        this.changeEditComponentId = this.changeEditComponentId.bind(this);
        this.changeEditIndex = this.changeEditIndex.bind(this);
    }

    changeShowCollapsibleContent(val?: boolean) {
        this.setState({
            showCollapsibleContent: !this.state.showCollapsibleContent
        });
    }


    // Toggle hamburger menu and set index to the active decision branch's index
    changeShowMenu(showMenuVal: boolean, showMenuIndexVal: number) {
        this.setState({
            showMenu: !showMenuVal,
            showMenuIndex: showMenuIndexVal
        });
    }
    changeEditComponentId(val: string, branchIndex?) {
        this.setState({
            editComponentId: val
        });
    }
    changeEditIndex(val: number) {
        if (val === null) {

        }
        this.setState({
            editIndex: val
        });
    }

    private debounceValue = (name: string, value: any, componentId: string) => {

        if (this.inputTimeout) {
            clearTimeout(this.inputTimeout);
        }

        this.inputTimeout = setTimeout(() => {
            this.props.updateComponentName(name, value, componentId)
        }, 0);
    }

    // updateComponentName = (key: string, value: any, componentId?: string) => {
    //     store.dispatch({ type: types.UPDATE_PROPERTY, componentId: this.state.editComponentId, key: key, value: value });
    // }

    dismissErrorMessage = () => {
        store.dispatch({
            type: types.SET_ERROR_MESSAGE_DISMISSED,
            errorMessageDismissed: true
        });

    }

    toggleDialog = (componentId: string, controlIndex: number, previousOutputBlock: any, layoutPanelIndex?: number) => {

        let { toggleDialog, previousOutputBlocks, component } = this.props;
        toggleDialog(componentId, controlIndex, previousOutputBlocks, layoutPanelIndex);

    };

    toggleLoopingDialog = (componentId: string) => {

        let { toggleControlBlockLoopingDialog, previousOutputBlocks } = this.props;

        toggleControlBlockLoopingDialog(componentId, previousOutputBlocks);

    }

    toggleLoopConfigDialog = (componentId: string) => {

        let { toggleLoopConfigDialog, previousOutputBlocks } = this.props;

        toggleLoopConfigDialog(componentId, previousOutputBlocks);

    }

    getMenu = (branchIndex?): IContextualMenuItem[] => {

        let menu: IContextualMenuItem[] = clone(COMPONENT_MENU);
        let { component, isStartComponent } = this.props;

        let isSubmission = component.ComponentType.ComponentTypeId === EComponentTypes.submission;
		// let isBlock = component.ComponentType.ComponentTypeId === EComponentTypes.block;

		// if (isBlock) {
		// 	menu.push(
		// 		{
		// 			key: 'Configure Looping',
		// 			icon: 'Configure Looping',
		// 			name: 'Configure Looping'
		// 		}
		// 	);
		// 	menu[2].onClick = () => {
		// 		this.toggleLoopingDialog(component.Id)
		// 	}

		// }

        if (component.ComponentType.ComponentTypeId === EComponentTypes.summary) {
            menu[0].disabled = true;
        }
        else if (isSubmission) {
            menu[0].onClick = () => {
                this.props.toggleSubmissionConfigDialog(component.Id);
            };
        }
        else {
            if (component && component.ComponentType.ComponentTypeId === EComponentTypes.sharedJourney) {
                menu[0].disabled = true
            } else {
                menu[0].onClick = () => {
                    if (component && (component.ComponentType.ComponentTypeId === EComponentTypes.block || component.ComponentType.ComponentTypeId === EComponentTypes.step)) {
                        this.props.toggleSidebar(component, false);
                    } else {
                        this.changeEditComponentId(component.Id, branchIndex);
                        this.changeEditIndex(branchIndex);
                    }
                };
            }
        }

        if (isStartComponent)
            menu[1].disabled = true;
        else {
            menu[1].onClick = () => {
                this.props.deleteComponent(component.Id);
            };
        }

        return menu;

    }


    getComponentDetails = (): JSX.Element => {

        let { component, components, toggleActionConfigDialog, toggleDecisionConfigDialog, toggleJourneySummaryDialog, previousOutputBlocks, setNextComponentId,
            toggleSharedJourneyConfig, toggleSubmissionConfigDialog, toggleRedirectConfigDialog, addNewLayoutPanel, inLoop, showMenu, toggleShowMenu, toggleMenu, toggleSidebar } = this.props;
        let typeId: EComponentTypes = component.ComponentType.ComponentTypeId;
        let element: JSX.Element;

        switch (typeId) {

            case EComponentTypes.block:
                element = <ControlList controls={component.ControlBlock.Controls}
                    getMenu={this.getMenu}
                    toggleShowMenu={toggleShowMenu}
                    showMenu={showMenu}
                    toggleMenu={toggleMenu}
                    toggleSidebar={toggleSidebar}
                    layoutPanels={component.ControlBlock.LayoutPanels}
                    toggleDialog={this.toggleDialog}
                    toggleLoopingDialog={this.toggleLoopingDialog}
                    componentId={component.Id}
                    inLoop={inLoop}
                    previousOutputBlocks={previousOutputBlocks}
                    component={component}
                    controlIndex={store.getState().modalState.controlConfig.controlIndex}
                    dismissErrorMessage={this.dismissErrorMessage}
                    addNewLayoutPanel={addNewLayoutPanel} />;
                break;

            case EComponentTypes.decision:
                element = <Decision componentDialogToggle={this.componentDialogToggle} toggleDecisionConfigDialog={toggleDecisionConfigDialog} component={component} componentId={component.Id} previousOutputBlocks={previousOutputBlocks} setNextComponentId={setNextComponentId} conditions={component.Decision.Branches} />;
                break;

            case EComponentTypes.action:
                element = <Action previousOutputBlocks={previousOutputBlocks} toggleActionConfigDialog={toggleActionConfigDialog} componentId={component.Id} />;
                break;

            case EComponentTypes.summary:
                element = <Summary previousOutputBlocks={previousOutputBlocks} toggleJourneySummaryDialog={toggleJourneySummaryDialog} componentId={component.Id} />;
                break;

            case EComponentTypes.sharedJourney:
                let journeyId = PropertyHelper.getPropertyValue(component.SharedJourney.Properties, 'JourneyId');
                let journeyName = journeyId ? SharedJourneyHelper.getSharedJourneyName(journeyId) : null;
                element = <SharedJourney previousOutputBlocks={previousOutputBlocks} journeyName={journeyName} componentId={component.Id} toggleSharedJourneyConfig={toggleSharedJourneyConfig} />;
                break;

            case EComponentTypes.submission:
                element = <Submission componentId={component.Id} toggleSubmissionConfigDialog={toggleSubmissionConfigDialog} />;
                break;

            case EComponentTypes.redirect:
                let to: any = PropertyHelper.getPropertyValue(component.Redirect.Properties, REDIRECT_CANDIDATE_TYPE_PROPERTY_NAME);
                let message: string = PropertyHelper.getPropertyValue(component.Redirect.Properties, 'Message');
                element = <Redirect to={to} message={message} componentId={component.Id} toggleRedirectConfigDialog={toggleRedirectConfigDialog} />;
                break;

            case EComponentTypes.loop:
                // element = <Loop onClick={(e) => this.toggleLoopConfigDialog(component.Id)} componentId={component.Id} toggleLoopConfigDialog={this.toggleLoopConfigDialog} />;
                element = <Loop componentId={component.Id} toggleLoopConfigDialog={this.toggleLoopConfigDialog} />;
                break;

            default:
                element = (null);

        }

        return element;

    }

    // initialize modal state to display the config on creation
    componentDidMount(): void {
        let {
            component, invalidConnection, toggleSidebar, toggleDialog, toggleActionConfigDialog, toggleSharedJourneyConfig, toggleJourneySummaryDialog,
            toggleRedirectConfigDialog, toggleSubmissionConfigDialog, toggleLoopConfigDialog,
            toggleMenu, updateProperty, children, branchId, previousOutputBlocks, toggleDecisionConfigDialog, isCollapsibleComponent
        } = this.props;

        if (!isCollapsibleComponent) {
            if (component.ComponentType.ComponentTypeId === EComponentTypes.sharedJourney)
                toggleSharedJourneyConfig(component.Id, previousOutputBlocks);
            else if (component.ComponentType.ComponentTypeId === EComponentTypes.action)
                toggleActionConfigDialog(component.Id, previousOutputBlocks)
            else if (component.ComponentType.ComponentTypeId === EComponentTypes.decision)
                toggleDecisionConfigDialog(component.Id, previousOutputBlocks)
            else if (component.ComponentType.ComponentTypeId === EComponentTypes.summary)
                toggleJourneySummaryDialog(component.Id, previousOutputBlocks)
            else if (component.ComponentType.ComponentTypeId === EComponentTypes.redirect)
                toggleRedirectConfigDialog(component.Id)
            else if (component.ComponentType.ComponentTypeId === EComponentTypes.submission)
                toggleSubmissionConfigDialog(component.Id)
            else if (component.ComponentType.ComponentTypeId === EComponentTypes.loop)
                toggleLoopConfigDialog(component.Id, previousOutputBlocks)
            else if (component.ComponentType.ComponentTypeId === EComponentTypes.block)
                toggleDialog(component.Id, null, previousOutputBlocks)
        }
    }

    // returns object with just the properties passed in targetValue string list
    getObjectWithProperties(object, targetValue: string[]) {
        const result = {};
        targetValue.forEach(x => {
            for (const key in object) {
                if (object.hasOwnProperty(key) && key === x) {
                    result[key] = object[key];
                }
            }
        })
        return result;
    }

    // returns object by dropping properties passed in propToDelete
    deepDelete(obj, propToDelete) {
        for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
                if (typeof obj[key] === 'object' && obj[key] !== null) {
                    this.deepDelete(obj[key], propToDelete);
                } else if (key === propToDelete) {
                    delete obj[key];
                }
            }
        }
        return obj;
    }


    // manage actionConfigDialog modal state for action component
    componentDialogToggle(pComponent?: IComponent, pPreviousOutputBlocks?: any, isDecisionBranch?: boolean) {

        if (!pComponent && !pPreviousOutputBlocks) {
            let {
                component, previousOutputBlocks
            } = this.props;
            pComponent = component;
            pPreviousOutputBlocks = previousOutputBlocks;
        }
        // initialize required variables
        let componentId;
        let isNewActionComponent = false;;
        let controlId;
        let modalStateComponent;
        let processStateComponent;
        let processComponentExist;
        let componentModal;
        let componentTypeToCheck;
        let isFieldChanged = false;
        let isPropertyChanged = false;

        // from the openmodal, get the type of component to check
        const openModal = store.getState().modalState.modal.openModal;
        switch (openModal) {
            case EModalType.ActionConfig:
                componentId = store.getState().modalState.actionConfig.componentId;
                modalStateComponent = store.getState().modalState.actionConfig.action;
                processComponentExist = store.getState().processState.components[componentId] ? true : false;
                processStateComponent = componentId && processComponentExist ? store.getState().processState.components[componentId].Action : null;
                const modalActionName = modalStateComponent && modalStateComponent.Properties.filter(x => x.Name === 'Action Name')[0];
                const processActionName = processStateComponent && processStateComponent.Properties.filter(x => x.Name === 'Action Name')[0];
                modalActionName.Value = processActionName && processActionName.Value;
                isNewActionComponent = processStateComponent && processStateComponent.ActionType ? false : true;
                isFieldChanged = store.getState().modalState.actionConfig.isFieldChanged;
                isPropertyChanged = store.getState().modalState.actionConfig.isPropertyChanged;
                componentModal = EModalType.ActionConfig;
                break;
            case EModalType.ControlConfig:
                componentId = store.getState().modalState.controlConfig.componentId;
                controlId = store.getState().modalState.controlConfig.control.ControlId;
                modalStateComponent = store.getState().modalState.controlConfig.control;
                processComponentExist = store.getState().processState.components[componentId] ? true : false;
                processStateComponent = (componentId && controlId && processComponentExist) ? store.getState().processState.components[componentId].ControlBlock.Controls.filter(x => x.ControlId === controlId)[0] : null;
                componentModal = EModalType.ControlConfig;
                break;
            case EModalType.DecisionConfig:
                componentId = store.getState().modalState.decisionConfig.componentId;
                modalStateComponent = store.getState().modalState.decisionConfig.decision;
                processComponentExist = store.getState().processState.components[componentId] ? true : false;
                processStateComponent = componentId && processComponentExist ? store.getState().processState.components[componentId].Decision : null;
                componentModal = EModalType.DecisionConfig;
                break;
            case EModalType.LoopConfig:
                componentId = store.getState().modalState.loopConfigState.loopConfig.componentId;
                modalStateComponent = this.getObjectWithProperties(store.getState().modalState.loopConfigState.loopConfig, ['OutputValues', 'Properties']);
                processComponentExist = store.getState().processState.components[componentId] ? true : false;
                processStateComponent = componentId && processComponentExist ? this.getObjectWithProperties(store.getState().processState.components[componentId].Loop, ['OutputValues', 'Properties']) : null;
                componentModal = EModalType.ControlConfig;
                break;
            case EModalType.Summary:
                componentId = store.getState().modalState.sharedJourneyConfig.SharedJourney.ComponentId;
                modalStateComponent = store.getState().modalState.sharedJourneyConfig.SharedJourney;
                processComponentExist = store.getState().processState.components[componentId] ? true : false;
                processStateComponent = componentId && processComponentExist ? store.getState().processState.components[componentId].SharedJourney : null;
                componentModal = EModalType.ActionConfig;
                break;
            case EModalType.SharedJourneyConfig:
                componentId = store.getState().modalState.sharedJourneyConfig.SharedJourney.ComponentId;
                modalStateComponent = store.getState().modalState.sharedJourneyConfig.SharedJourney;
                processComponentExist = store.getState().processState.components[componentId] ? true : false;
                processStateComponent = componentId && processComponentExist ? store.getState().processState.components[componentId].SharedJourney : null;
                componentModal = EModalType.ActionConfig;
                break;
            case EModalType.SubmissionConfig:
                componentId = store.getState().modalState.submissionConfig.componentId;
                modalStateComponent = store.getState().modalState.submissionConfig.submission;
                processComponentExist = store.getState().processState.components[componentId] ? true : false;
                processStateComponent = componentId && processComponentExist ? store.getState().processState.components[componentId].Submission : null;
                componentModal = EModalType.SubmissionConfig;
                break;
            case EModalType.RedirectConfig:
                componentId = store.getState().modalState.redirectConfig.componentId;
                modalStateComponent = store.getState().modalState.redirectConfig.redirect.Properties;
                processComponentExist = store.getState().processState.components[componentId] ? true : false;
                processStateComponent = componentId && processComponentExist ? store.getState().processState.components[componentId].Redirect.Properties : null;
                componentModal = EModalType.RedirectConfig;
                break;
            default:
                break;
        }

        // detect any unsaved changes in the component
        if (openModal != EModalType.None) {
            if (componentId && modalStateComponent && processStateComponent) {

                const modalComponent = this.deepDelete(modalStateComponent, 'IsInvisible');
                const processComponent = this.deepDelete(processStateComponent, 'IsInvisible');

                if (isNewActionComponent) {
                    if (isPropertyChanged) {
                        store.dispatch({
                            type: types.TOGGLE_CONFIRMATION_DIALOG,
                            operationType: EConfirmationOperationType.ToggleComponent,
                            title: 'Unsaved Changes',
                            message: 'You have some unsaved changes. Please save to prevent any lost changes or cancel to discard them.',
                            isOpen: true,
                            okButtonLabel: 'Ok',
                            isCancelButtonHidden: true,
                            modalStateComponentId: modalStateComponent.Id,
                            componentId: pComponent.Id,
                            openModal: openModal,
                            componentModal: componentModal,
                            previousOutputBlocks: pPreviousOutputBlocks
                        })
                        return;
                    }
                }
                else if (JSON.stringify(modalComponent) !== JSON.stringify(processComponent) || isFieldChanged) {
                    store.dispatch({
                        type: types.TOGGLE_CONFIRMATION_DIALOG,
                        operationType: EConfirmationOperationType.ToggleComponent,
                        title: 'Unsaved Changes',
                        message: 'You have some unsaved changes. Please save to prevent any lost changes or cancel to discard them.',
                        isOpen: true,
                        okButtonLabel: 'Ok',
                        isCancelButtonHidden: true,
                        modalStateComponentId: modalStateComponent.Id,
                        componentId: pComponent.Id,
                        openModal: openModal,
                        componentModal: componentModal,
                        previousOutputBlocks: pPreviousOutputBlocks
                    })
                    return;
                }
            }
        }

        // acc. to the component type, perform appropriate action if no unsaved changes are detected
        // the implementation of this code is also done after accepting the confirmation message
        if (isDecisionBranch) {
            this.changeShowCollapsibleContent()
        } else {
            switch (pComponent.ComponentType.ComponentTypeId) {
                case EComponentTypes.action:
                    this.actionConfigDialogToggle();
                    break;
                case EComponentTypes.block:
                    this.dialogToggle();
                    break;
                case EComponentTypes.decision:
                    this.decisionConfigDialogToggle();
                    break;
                case EComponentTypes.loop:
                    this.loopConfigDialogToggle();
                    break;
                case EComponentTypes.sharedJourney:
                    this.sharedJourneyToggle();
                    break;
                case EComponentTypes.summary:
                    this.journeySummaryDialogToggle();
                    break;
                case EComponentTypes.submission:
                    this.submissionConfigDialogToggle();
                    break;
                case EComponentTypes.redirect:
                    this.redirectConfigDialogToggle();
                    break;
                default:
                    break;
            }
        }
    }

    // manage actionConfigDialog modal state for action component
    actionConfigDialogToggle() {
        let {
            component, toggleActionConfigDialog, previousOutputBlocks
        } = this.props;

        if (store.getState().modalState.actionConfig.componentId === component.Id &&
            store.getState().modalState.modal.openModal === EModalType.ActionConfig) {
            store.getState().modalState.actionConfig.componentId = '';
        }
        else {
            toggleActionConfigDialog(component.Id, previousOutputBlocks);
        }
    }

    // manage dialog modal state for block component
    dialogToggle() {
        let {
            component, toggleDialog, previousOutputBlocks
        } = this.props;

        if (store.getState().modalState.controlConfig.componentId === component.Id &&
            store.getState().modalState.modal.openModal === EModalType.ControlConfig) {
            store.getState().modalState.controlConfig.componentId = '';
        }
        else {
            toggleDialog(component.Id, null, previousOutputBlocks);
        }
    }

    // manage actionConfigDialog modal state for action component
    decisionConfigDialogToggle() {
        let {
            component, toggleDecisionConfigDialog, previousOutputBlocks
        } = this.props;

        if (store.getState().modalState.decisionConfig.componentId.length > 0 &&
            store.getState().modalState.modal.openModal === EModalType.DecisionConfig) {
            store.getState().modalState.decisionConfig.componentId = '';
        }
        else {
            toggleDecisionConfigDialog(component.Id, previousOutputBlocks);
        }
    }
    // manage loopConfigDialog modal state for loop component
    loopConfigDialogToggle() {
        let {
            component, toggleLoopConfigDialog, previousOutputBlocks
        } = this.props;

        if (store.getState().modalState.loopConfigState.loopConfig.componentId === component.Id &&
            store.getState().modalState.modal.openModal === EModalType.LoopConfig) {
            store.getState().modalState.loopConfigState.loopConfig.componentId = '';
        }
        else {
            toggleLoopConfigDialog(component.Id, previousOutputBlocks);
        }
    }

    // manage sharedJourneyConfig modal state for journey component
    sharedJourneyToggle() {
        let {
            component, invalidConnection, toggleSidebar, toggleSharedJourneyConfig, toggleMenu, updateProperty, children, branchId, previousOutputBlocks, toggleDecisionConfigDialog
        } = this.props;

        if (store.getState().modalState.sharedJourneyConfig.SharedJourney.ComponentId === component.Id &&
            store.getState().modalState.modal.openModal === EModalType.SharedJourneyConfig) {
            store.getState().modalState.sharedJourneyConfig.SharedJourney.ComponentId = '';
        }
        else {
            toggleSharedJourneyConfig(component.Id, previousOutputBlocks);
        }
    }

    // manage journeySummaryDialog modal state for summary component
    journeySummaryDialogToggle() {
        let {
            component, toggleJourneySummaryDialog, previousOutputBlocks
        } = this.props;
        if (store.getState().modalState.modal.openModal === EModalType.Summary)
            store.getState().modalState.modal.openModal = EModalType.None;
        else
            store.getState().modalState.modal.openModal = EModalType.Summary;
    }
    // manage redirectConfigDialog modal state for redirect component
    redirectConfigDialogToggle() {
        let {
            component, toggleRedirectConfigDialog
        } = this.props;

        if (store.getState().modalState.redirectConfig.componentId === component.Id &&
            store.getState().modalState.modal.openModal === EModalType.RedirectConfig) {
            store.getState().modalState.redirectConfig.componentId = '';
        }
        else {
            toggleRedirectConfigDialog(component.Id);
        }

    }

    // manage submissionConfigDialog modal state for submission component
    submissionConfigDialogToggle() {
        let {
            component, toggleSubmissionConfigDialog
        } = this.props;

        if (store.getState().modalState.submissionConfig.componentId === component.Id &&
            store.getState().modalState.modal.openModal === EModalType.SubmissionConfig) {
            store.getState().modalState.submissionConfig.componentId = '';
        }
        else {
            toggleSubmissionConfigDialog(component.Id);
        }

    }

    public render() {

        let {
            component, invalidConnection, toggleSidebar, toggleSharedJourneyConfig, toggleMenu, updateProperty, children, branchId, previousOutputBlocks, toggleDecisionConfigDialog,
            isCollapsibleComponent,
            saveEditedBranch,
            changeEditComponentId,
            nameChange,
            deleteBranch,
            decisionItems,
            parentDecisionID,
            index,
            collapsibleContextMenu,
            toggleShowMenu,
            showMenu,
            editComponentId,
            editIndex,


        } = this.props;

        let { Id, NextComponent } = component;
        let componentName: string = ComponentHelper.getName(component);
        let type: IComponentType = component.ComponentType;
        let componentDetails: JSX.Element = this.getComponentDetails();
        let menu = this.getMenu();
        let icon: string = ComponentHelper.getComponentIcon(type);

        let contextMenu: JSX.Element = component.openMenu
            && <ContextualMenu target={'.more-' + component.Id}
                shouldFocusOnMount={false}
                onDismiss={() => toggleMenu(component.Id)}
                directionalHint={DirectionalHint.bottomRightEdge}
                items={menu}
                isBeakVisible={true}
                beakWidth={15} />;

        let childrenElements: JSX.Element = children && React.Children.count(children)
            && <div className="component-child-wrapper">
                {children}
            </div>;

        let classNames: string[] = [
            'component',
            'component-arrow',
            'anim-1',
            'ms-u-slideRightIn40'
        ];

        if (branchId && branchId !== 'root')
            classNames.push('in-branch');
        if (invalidConnection)
            classNames.push('invalid');

        let showPropertiesOnComponent: boolean = component.ComponentType.ComponentTypeId !== EComponentTypes.block && component.ComponentType.ComponentTypeId !== EComponentTypes.redirect;
        let properties = ComponentHelper.getProperties(component, true);
        // let shouldRender = store.getState().modalState.decisionConfig.componentId ? component.Id === store.getState().modalState.decisionConfig.componentId : false;
        let commonHeaderItem: JSX.Element =
            <div className={(this.state.editComponentId === component.Id) ? "component-head-container" : ""}>
                <i className={'ms-Icon ms-Icon--' + icon} aria-hidden="true" /> <span className="component-name">

                    {
                        this.state.editComponentId === component.Id ?
                            // editIndex === index &&
                            // store.getState().modalState.decisionConfig.branchEditIndex === 0 ?
                            <OutsideClickHandler
                                // onClick={(event) => event.stopPropagation()}
                                onOutsideClick={() => {
                                    this.changeEditComponentId(null);
                                }}>
                                <TextField
                                    autoFocus
                                    onFocus={(e) => e.currentTarget.setSelectionRange(e.currentTarget.value.length, e.currentTarget.value.length)}
                                    className={"component-header-input "}
                                    label={null}
                                    value={properties[0].Value}
                                    onChanged={(val) => this.debounceValue(properties[0].Name, val, this.state.editComponentId)}
                                    onClick={(event) => event.stopPropagation()}
                                    onKeyDown={(event) => {
                                        if (event.key === ' ') {
                                            const textField = (event.target as HTMLInputElement);
                                            const { selectionStart, selectionEnd, value } = textField;
                                            const newValue = value.substring(0, selectionStart) + ' ' + value.substring(selectionEnd);
                                            (event.target as HTMLInputElement).value = newValue;
                                            (event.target as HTMLInputElement).selectionStart = textField.selectionEnd = selectionStart + 1; // Move the cursor to the end of the appended text
                                            event.preventDefault();
                                        } else if (event.key === 'Enter') {
                                            this.changeEditComponentId(null);
                                        }

                                    }}

                                />
                            </OutsideClickHandler> : showPropertiesOnComponent ? <PropertiesTitle componentName={componentName} properties={ComponentHelper.getProperties(component)} componentId={component.Id} primaryOnly={true} change={updateProperty} /> : componentName
                    }

                </span>
                <div className="actions">
                    <Button buttonType={ButtonType.icon}
                        icon='More'
                        title='More'
                        className={'action more-' + component.Id}
                        onClick={(e) => { toggleMenu(component.Id); e.stopPropagation(); return true; }} />
                    {contextMenu}
                </div>

            </div >
        let commonContentItem: JSX.Element = <div className="component-inner">
            <div className="component-summary ms-font-m">
                {componentDetails}
            </div>
        </div>

        let result: JSX.Element;
        let isStepComponent: boolean = true;
        let typeId: EComponentTypes = component.ComponentType.ComponentTypeId;

        switch (typeId) {

            case EComponentTypes.block:
                isStepComponent = false;
                // let isControlPresent = false;
                // component.ControlBlock.LayoutPanels.forEach(element => {
                //     if (element.Controls.length) {
                //         isControlPresent = true;
                //         return;
                //     }
                // });

                var isMultiColumnPanelPresent = false;
                var prevColumnWidth = 1;
                component.ControlBlock.LayoutPanels.forEach(element => {
                    const currentColumnWidth = eval(element.Properties.filter(x => x.Name.toLowerCase() === 'width')[0].Value);
                    if (currentColumnWidth + prevColumnWidth <= 1) {
                        isMultiColumnPanelPresent = true;
                        return;
                    } else {
                        prevColumnWidth = currentColumnWidth;
                    }
                });
                // Controls.map(x => x.OutputValues).flat()
                const blockClass = store.getState().modalState.controlConfig.componentId &&
                    component.Id === store.getState().modalState.controlConfig.componentId &&
                    // isControlPresent &&
                    isMultiColumnPanelPresent &&
                    store.getState().modalState.modal.openModal === EModalType.ControlConfig ? "block-head-expanded"
                    : "block-head-collapsed";
                result = <div className={
                    component.Id === store.getState().modalState.controlConfig.componentId &&
                        // isControlPresent &&
                        isMultiColumnPanelPresent &&
                        store.getState().modalState.modal.openModal === EModalType.ControlConfig ? "component-inner block-inner-expanded" : "component-inner block-inner-collapsed"}>
                    <Collapsible overflowWhenOpen={'visible'}
                        handleTriggerClick={() => {
                            this.componentDialogToggle();
                        }}
                        trigger={<div className={"component-head " + blockClass + " custom-bg-" + type.Name} onClick={() => { toggleSidebar(component, true); }}>
                            {commonHeaderItem}
                        </div>} open={store.getState().modalState.controlConfig.componentId ?
                            component.Id === store.getState().modalState.controlConfig.componentId &&
                            store.getState().modalState.modal.openModal === EModalType.ControlConfig
                            : false}>
                        <div className="component-inner">
                            <div className="block-component-summary ms-font-m">
                                {component.Id === store.getState().modalState.controlConfig.componentId &&
                                    store.getState().modalState.modal.openModal === EModalType.ControlConfig ? componentDetails : null}
                                {/* <CascadeContainer /> */}
                            </div>
                        </div>
                    </Collapsible>
                </div >
                { childrenElements }
                break;

            case EComponentTypes.decision:
                isStepComponent = false;
                result = <div className="component-inner">
                    <div className={"component-head custom-bg-" + type.Name}
                        onClick={() => {
                            this.componentDialogToggle();
                            toggleSidebar(component, true);
                        }}>
                        {commonHeaderItem}
                    </div>
                </div >
                { childrenElements }
                break;

            case EComponentTypes.action:
                isStepComponent = false;
                result = <div className="component-inner">
                    <Collapsible
                        overflowWhenOpen="visible"
                        handleTriggerClick={(event) => {
                            this.componentDialogToggle();
                            store.dispatch({
                                type: types.SET_ERROR_MESSAGE_DISMISSED,
                                errorMessageDismissed: true
                            });

                        }}
                        onClose={() => {
                            // Remove field error.
                            store.dispatch({
                                type: types.REMOVE_FIELD_ERROR
                            });

                        }}
                        trigger={<div className={"component-head custom-bg-" + type.Name} onClick={() => { toggleSidebar(component, true); }}>
                            {commonHeaderItem}
                            {/* </div>} open={store.getState().modalState.actionConfig.componentId ? component.Id === store.getState().modalState.actionConfig.componentId : false}> */}
                        </div>} open={store.getState().modalState.actionConfig.componentId ? component.Id === store.getState().modalState.actionConfig.componentId &&
                            store.getState().modalState.modal.openModal === EModalType.ActionConfig : false}>
                        <div className="component-inner">
                            <div className="component-summary ms-font-m">
                                {/* {componentDetails} */}
                                {component.Id === store.getState().modalState.actionConfig.componentId &&
                                    store.getState().modalState.modal.openModal === EModalType.ActionConfig ? <CascadeContainer /> : null}
                            </div>
                        </div>
                    </Collapsible>
                </div >
                { childrenElements }
                break;

            case EComponentTypes.summary:
                isStepComponent = false;
                result = <div className="component-inner">
                    <Collapsible overflowWhenOpen="visible"
                        handleTriggerClick={() => this.componentDialogToggle()}
                        trigger={<div className={"component-head custom-bg-" + type.Name} onClick={() => { toggleSidebar(component, true); }}>
                            {commonHeaderItem}
                        </div>} open={store.getState().modalState.modal.openModal === EModalType.Summary}>
                        <div className="component-inner">
                            <div className="component-summary ms-font-m">
                                {/* {componentDetails} */}
                                {store.getState().modalState.modal.openModal === EModalType.Summary ? <CascadeContainer /> : null}
                            </div>
                        </div>
                    </Collapsible>
                </div>
                { childrenElements }
                break;

            case EComponentTypes.sharedJourney:
                isStepComponent = false;
                result = <div className="component-inner">
                    <Collapsible overflowWhenOpen="visible"
                        handleTriggerClick={() => this.componentDialogToggle()}
                        trigger={<div className={"component-head custom-bg-" + type.Name} onClick={() => { toggleSidebar(component, true); }}>
                            {commonHeaderItem}
                        </div>} open={store.getState().modalState.sharedJourneyConfig.SharedJourney.ComponentId ? component.Id === store.getState().modalState.sharedJourneyConfig.SharedJourney.ComponentId &&
                            store.getState().modalState.modal.openModal === EModalType.SharedJourneyConfig : false}>
                        <div className="component-inner">
                            <div className="component-summary ms-font-m">
                                {/* {componentDetails} */}
                                {component.Id === store.getState().modalState.sharedJourneyConfig.SharedJourney.ComponentId &&
                                    store.getState().modalState.modal.openModal === EModalType.SharedJourneyConfig ? <CascadeContainer /> : null}

                            </div>
                        </div>
                    </Collapsible>
                </div>
                { childrenElements }
                break;

            case EComponentTypes.submission:
                isStepComponent = false;
                result = <div className="component-inner">
                    <Collapsible overflowWhenOpen="visible"
                        handleTriggerClick={() => this.componentDialogToggle()}
                        trigger={<div className={"component-head custom-bg-" + type.Name} onClick={() => { toggleSidebar(component, true); }}>
                            {commonHeaderItem}
                        </div>} open={store.getState().modalState.submissionConfig.componentId ? component.Id === store.getState().modalState.submissionConfig.componentId &&
                            store.getState().modalState.modal.openModal === EModalType.SubmissionConfig : false}>
                        <div className="component-inner">
                            <div className="component-summary ms-font-m">
                                {/* {componentDetails} */}
                                {component.Id === store.getState().modalState.submissionConfig.componentId &&
                                    store.getState().modalState.modal.openModal === EModalType.SubmissionConfig ? <CascadeContainer /> : null}

                            </div>
                        </div>

                    </Collapsible>
                </div>
                { childrenElements }
                break;

            case EComponentTypes.redirect:
                let redirectState = store.getState().modalState.redirectConfig.componentId;
                isStepComponent = false;
                result = <div className="component-inner">
                    <Collapsible overflowWhenOpen="visible"
                        handleTriggerClick={() => this.componentDialogToggle()}
                        trigger={<div className={"component-head custom-bg-" + type.Name} onClick={() => { toggleSidebar(component, true); }}>
                            {commonHeaderItem}
                        </div>} open={store.getState().modalState.redirectConfig.componentId ? component.Id === store.getState().modalState.redirectConfig.componentId &&
                            store.getState().modalState.modal.openModal === EModalType.RedirectConfig : false}>
                        <div className="component-inner">
                            <div className="component-summary ms-font-m">
                                {/* {componentDetails} */}
                                {component.Id === store.getState().modalState.redirectConfig.componentId &&
                                    store.getState().modalState.modal.openModal === EModalType.RedirectConfig ? <CascadeContainer /> : null}


                            </div>
                        </div>


                    </Collapsible>
                </div>
                { childrenElements }
                break;

            case EComponentTypes.loop:
                isStepComponent = false;
                result = <div className="component-inner">
                    <Collapsible overflowWhenOpen="visible"
                        handleTriggerClick={() => this.componentDialogToggle()}
                        trigger={<div className={"component-head custom-bg-" + type.Name} onClick={() => { toggleSidebar(component, true); }}>
                            {commonHeaderItem}
                        </div>} open={store.getState().modalState.loopConfigState.loopConfig.componentId ? component.Id === store.getState().modalState.loopConfigState.loopConfig.componentId &&
                            store.getState().modalState.modal.openModal === EModalType.LoopConfig : false}>
                        <div className="component-inner">
                            <div className="component-summary ms-font-m">
                                {/* {componentDetails} */}
                                {component.Id === store.getState().modalState.loopConfigState.loopConfig.componentId &&
                                    store.getState().modalState.modal.openModal === EModalType.LoopConfig ? <CascadeContainer /> : null}
                            </div>
                        </div>
                    </Collapsible>
                </div>
                { childrenElements }
                break;
            default:
                result = null;

        }

        return (
            isStepComponent ?
                <div className={component.ComponentType.Name === "Summary" ?
                    classNames.join(' control-dialog width-component ') : classNames.join(' ')}
                    data-id={Id} data-next={NextComponent && NextComponent.ComponentId || 'empty'}>
                    <div className="component-inner">
                        <div className={"component-head custom-bg-" + type.Name} onClick={() => { toggleSidebar(component, true); }}>
                            {commonHeaderItem}
                        </div>
                    </div>

                    {childrenElements}
                </div>
                :
                isCollapsibleComponent ?
                    <div className="children">
                        <Collapsible
                            overflowWhenOpen="visible"
                            open={true}
                            handleTriggerClick={() => {
                                this.componentDialogToggle(component, previousOutputBlocks, true);
                                // this.changeShowCollapsibleContent();
                            }}
                            openedClassName={'collapsible-open'}
                            contentHiddenWhenClosed={true}
                            trigger={
                                <div className="component-head decision-head">
                                    <span className="component-name">
                                        {
                                            editComponentId === component.Id &&
                                                editIndex === index &&
                                                store.getState().modalState.decisionConfig.branchEditIndex === index ?
                                                <OutsideClickHandler
                                                    onOutsideClick={() => {
                                                        saveEditedBranch(index);
                                                        this.changeEditComponentId(null);
                                                    }}>
                                                    <TextField
                                                        className="component-header-input"
                                                        label={null}
                                                        value={store.getState().modalState.decisionConfig.editedBranch
                                                            ? store.getState().modalState.decisionConfig.editedBranch.Name : null}
                                                        onChanged={nameChange}
                                                        onClick={(event) => event.stopPropagation()}
                                                        onKeyDown={(event) => {
                                                            if (event.key === ' ') {
                                                                const textField = (event.target as HTMLInputElement);
                                                                const { selectionStart, selectionEnd, value } = textField;
                                                                const newValue = value.substring(0, selectionStart) + ' ' + value.substring(selectionEnd);
                                                                (event.target as HTMLInputElement).value = newValue;
                                                                (event.target as HTMLInputElement).selectionStart = textField.selectionEnd = selectionStart + 1; // Move the cursor to the end of the appended text
                                                                event.preventDefault();
                                                            } else if (event.key === 'Enter') {
                                                                saveEditedBranch(index);
                                                                this.changeEditComponentId(null);
                                                            }
                                                        }}
                                                    />
                                                </OutsideClickHandler> :
                                                decisionItems[0].props.conditions[index].Name ? decisionItems[0].props.conditions[index].Name : 'Decision Branch'
                                        }

                                    </span>
                                    {decisionItems[0].props.conditions.length > 0 ?
                                        <div className="actions">

                                            {/* hamburger menu on decision branch head */}
                                            <div className="actions" >
                                                <Button buttonType={ButtonType.icon}
                                                    icon='More'
                                                    title='More'
                                                    className={'action branch-' + component.Id + '_branch_' + index}
                                                    onClick={(e) => {
                                                        toggleDecisionConfigDialog(parentDecisionID, previousOutputBlocks);
                                                        changeEditComponentId(component.Id);
                                                        toggleShowMenu(showMenu, index);
                                                        e.stopPropagation();
                                                        return true;
                                                    }} />
                                                {collapsibleContextMenu}
                                            </div>
                                        </div>
                                        : null
                                    }
                                </div>
                            }>
                            {this.state.showCollapsibleContent && <div className="decision-collapsible-content"> {decisionItems}</div>}</Collapsible >
                    </div >
                    :
                    <div className={component.ComponentType.Name === "Summary" ? classNames.join(' control-dialog width-component ') : classNames.join(' ')} data-id={Id} data-next={NextComponent && NextComponent.ComponentId || 'empty'}>
                        {result}
                    </div>
        );

    };

};



// WEBPACK FOOTER //
// ./source/ts/components/components/component.tsx